import {
  ButtonSecondary,
  Skeleton,
  SkeletonText,
  Typography,
} from '@creditas-ui/react'
import { Routes } from 'config/routes'
import React from 'react'
import { generatePath, useHistory } from 'react-router-dom'
import { formatMoney } from 'shared/helpers'
import { ItemValueDetail } from '../ItemValueDetail'
import {
  ContentResumeDetailStyle,
  GridItems,
  ItemInformation,
} from './ContentResumeDetail.styles'

const ContentResumeDetail = ({ id, loading, proposalDetail, ...props }) => {
  const history = useHistory()
  const redirectLeadDetail = generatePath(Routes.Leads.Details, { id })

  function redirectToDetail() {
    history.push(redirectLeadDetail)
  }

  return (
    <ContentResumeDetailStyle component="div" {...props}>
      {loading ? (
        <SkeletonText
          color="light"
          lines={1}
          variant="heading"
          mb="12px"
          widthLastChildren="80%"
        />
      ) : (
        <Typography
          mb="24px"
          component="h2"
          variant="bodyMdBold"
          color="neutral.80"
        >
          Resumo {proposalDetail?.resume}
        </Typography>
      )}

      <GridItems>
        <ItemInformation>
          {loading ? (
            <SkeletonText
              color="light"
              lines={2}
              variant="body"
              mr="12px"
              widthLastChildren="80%"
            />
          ) : (
            <>
              <Typography
                mb="8px"
                component="p"
                variant="bodySmRegular"
                color="neutral.60"
              >
                Valor {proposalDetail?.title}
              </Typography>
              <Typography
                color={`${
                  proposalDetail?.amountType === 'releasedAmount' ||
                  proposalDetail?.amountType === 'approvedCreditAmount'
                    ? 'primary.90'
                    : 'neutral.90'
                }`}
                component="span"
                variant="headingSmMedium"
              >
                {formatMoney(
                  proposalDetail?.values[proposalDetail?.amountType],
                )}
              </Typography>
            </>
          )}
        </ItemInformation>
        <ItemValueDetail loading={loading} title="" value="" />
        {proposalDetail?.feesDetail && (
          <>
            <ItemValueDetail
              loading={loading}
              title="Valor da parcela"
              value={`${formatMoney(
                proposalDetail?.values?.installmentValue,
              )} em ${proposalDetail?.values?.totalInstallments}x`}
            />
            <ItemValueDetail
              loading={loading}
              title="Total do empréstimo"
              value={formatMoney(proposalDetail?.values?.totalLoanAmount)}
            />
            <ItemValueDetail
              loading={loading}
              title="Taxa de juros"
              value={`${proposalDetail?.values?.monthlyInterestRate}%`}
            />

            <ItemValueDetail
              loading={loading}
              title="Tarifa de cadastro"
              value={formatMoney(proposalDetail?.values?.registrationFeeAmount)}
            />
            <ItemValueDetail
              loading={loading}
              title="IOF"
              value={formatMoney(proposalDetail?.values?.iofAmount)}
            />
            <ItemValueDetail
              loading={loading}
              title="CET"
              value={`${proposalDetail?.values?.monthlyCetRate}% a.m`}
            />
          </>
        )}
      </GridItems>

      {loading ? (
        <Skeleton color="light" height={20} width={150} />
      ) : (
        <ButtonSecondary
          onClick={() => redirectToDetail()}
          data-testid={`detail-${id}`}
        >
          Detalhes da proposta
        </ButtonSecondary>
      )}
    </ContentResumeDetailStyle>
  )
}

export { ContentResumeDetail }
